import styled, { css } from 'styled-components';
import { scrollbarStyle } from '@/utils';

export const DefaultListWrapper = styled.div<{ $gapSize: string; $itemWidth: string }>(
  ({ $gapSize, $itemWidth }) => css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(${$itemWidth}, max-content));
    gap: ${$gapSize};
    justify-content: center;
    padding: 0 ${$gapSize};
  `,
);

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  position: relative;

  ${({
    theme: {
      color: { ui4, ui6 },
    },
  }) => scrollbarStyle(ui4, ui6)}
`;

export const StatusInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoadingWrapper = styled.div`
  font-family: ${({
    theme: {
      font: { t1 },
    },
  }) => t1.fontFamily};
  color: ${({
    theme: {
      color: { ui3 },
    },
  }) => ui3};
`;
